import { render, staticRenderFns } from "./ClientSettingsTop.vue?vue&type=template&id=1161a746&scoped=true"
import script from "./ClientSettingsTop.vue?vue&type=script&lang=ts"
export * from "./ClientSettingsTop.vue?vue&type=script&lang=ts"
import style0 from "./ClientSettingsTop.vue?vue&type=style&index=0&id=1161a746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1161a746",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/client-settings-top.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2FClientSettingsTop.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports